import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Flyout.scss';
import { connect } from 'react-redux';
var Flyout = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Flyout, _Component);

  var _super = _createSuper(Flyout);

  function Flyout(props) {
    var _this;

    _classCallCheck(this, Flyout);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleFlyout", function () {
      var open = !_this.state.open;

      _this.setState({
        open: open
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Flyout, [{
    key: "render",
    value: function render() {
      if (!this.props.children) {
        // If no children provided, don't render anything.
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.flyoutStyle,
        className: "".concat(styles.flyoutWrapper, " ").concat(this.state.open ? '' : styles.closed)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.flyoutToggle,
        style: {
          backgroundColor: this.props.theme.colors.secondaryColor,
          borderColor: this.props.theme.colors.secondaryColor
        },
        onClick: this.toggleFlyout
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ".concat(this.state.open ? this.props.icons[0] : this.props.icons[1])
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.flyoutBody
      }, this.props.children));
    }
  }]);

  return Flyout;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.node,
  icons: PropTypes.array
}), _defineProperty(_class2, "defaultProps", {
  icons: ['ion-ios-arrow-right', 'ion-ios-arrow-left']
}), _temp)) || _class);
export { Flyout as default };